import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Settings() {
  const [form, setForm] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setForm(r.data || {})); }, []);
  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const save = async () => { await api.put("/settings", form); toast.success("Configurações salvas"); };

  const onLogo = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => update("logo_url", reader.result);
    reader.readAsDataURL(f);
  };

  return (
    <div className="p-10 max-w-[1000px]">
      <div className="flex items-end justify-between mb-8">
        <div><p className="overline">White Label</p><h1 className="font-heading text-4xl mt-2">Configurações da Marca</h1></div>
        <Button className="bg-[#C07C88] hover:bg-[#A86571]" onClick={save} data-testid="save-settings">Salvar</Button>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <Card className="p-6 shadow-none border-border">
          <p className="overline mb-4">Identidade Visual</p>
          <div className="space-y-4">
            <div><Label>Nome da empresa</Label><Input value={form.company_name || ""} onChange={(e) => update("company_name", e.target.value)} data-testid="company-name" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label>Cor primária</Label>
                <div className="flex items-center gap-2">
                  <input type="color" value={form.brand_primary || "#C07C88"} onChange={(e) => update("brand_primary", e.target.value)} className="h-10 w-14 rounded-md border border-border cursor-pointer" data-testid="color-primary" />
                  <Input value={form.brand_primary || ""} onChange={(e) => update("brand_primary", e.target.value)} />
                </div>
              </div>
              <div>
                <Label>Cor de destaque</Label>
                <div className="flex items-center gap-2">
                  <input type="color" value={form.brand_accent || "#D4AF37"} onChange={(e) => update("brand_accent", e.target.value)} className="h-10 w-14 rounded-md border border-border cursor-pointer" data-testid="color-accent" />
                  <Input value={form.brand_accent || ""} onChange={(e) => update("brand_accent", e.target.value)} />
                </div>
              </div>
            </div>
            <div>
              <Label>Logotipo</Label>
              <div className="flex items-center gap-3">
                {form.logo_url && <img src={form.logo_url} alt="" className="h-12 border border-border rounded" />}
                <input type="file" accept="image/*" onChange={onLogo} className="text-sm" data-testid="logo-upload" />
              </div>
            </div>
          </div>
        </Card>
        <Card className="p-6 shadow-none border-border">
          <p className="overline mb-4">Contato & Fiscal</p>
          <div className="space-y-4">
            <div><Label>E-mail</Label><Input value={form.contact_email || ""} onChange={(e) => update("contact_email", e.target.value)} data-testid="contact-email" /></div>
            <div><Label>Telefone</Label><Input value={form.contact_phone || ""} onChange={(e) => update("contact_phone", e.target.value)} data-testid="contact-phone" /></div>
            <div><Label>CNPJ/CPF</Label><Input value={form.tax_id || ""} onChange={(e) => update("tax_id", e.target.value)} data-testid="tax-id" /></div>
            <div><Label>Endereço</Label><Input value={form.contact_address || ""} onChange={(e) => update("contact_address", e.target.value)} data-testid="contact-address" /></div>
            <div><Label>Cidade (Pix)</Label><Input value={form.merchant_city || ""} onChange={(e) => update("merchant_city", e.target.value)} placeholder="SAO PAULO" data-testid="merchant-city" /></div>
          </div>
        </Card>
        <Card className="p-6 shadow-none border-border md:col-span-2">
          <p className="overline mb-4">Chave Pix (para receber sinal do cliente)</p>
          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <Label>Tipo</Label>
              <select
                value={form.pix_key_type || "email"}
                onChange={(e) => update("pix_key_type", e.target.value)}
                className="w-full h-10 px-3 border border-input rounded-md text-sm bg-white"
                data-testid="pix-key-type"
              >
                <option value="cpf">CPF</option>
                <option value="cnpj">CNPJ</option>
                <option value="email">E-mail</option>
                <option value="phone">Telefone</option>
                <option value="random">Chave aleatória</option>
              </select>
            </div>
            <div className="md:col-span-2">
              <Label>Chave Pix</Label>
              <Input value={form.pix_key || ""} onChange={(e) => update("pix_key", e.target.value)} placeholder="Sua chave para receber pagamentos" data-testid="pix-key" />
            </div>
          </div>
        </Card>
        <Card className="p-6 shadow-none border-border md:col-span-2">
          <p className="overline mb-4">Padrões de Orçamento</p>
          <div className="grid md:grid-cols-4 gap-4">
            <div className="md:col-span-3"><Label>Termos padrão</Label><Textarea rows={3} value={form.default_terms || ""} onChange={(e) => update("default_terms", e.target.value)} data-testid="default-terms" /></div>
            <div><Label>Validade padrão (dias)</Label><Input type="number" value={form.default_validity_days || 15} onChange={(e) => update("default_validity_days", +e.target.value)} data-testid="default-validity" /></div>
          </div>
        </Card>
      </div>
    </div>
  );
}
